import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/Endpoint";
import ResolveData from "../Reusable/ResolvedData";
import Modal from "../Reusable/Modal";
import { useEffect, useState } from "react";
import { DeleteIcon } from "../../Icons/DeleteIocn";
import ConfirmDialog from "../ConfirmDialog";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useForm } from "react-hook-form";
import usePostHook from "../../customHooks/usePostHook";
import moment from "moment";

const SubmittedFormData = (props: any) => {
  const { fields, formId, isReply, handleDelete, created } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [isReplyOpen, setIsReplyOpen] = useState(false);
  const [replyMessage, setReplyMessage] = useState("");
  const [selectedObject, setSelectedObject] = useState(null);

  // const jsonFormatFieldInfo = JSON.parse(JSON.stringify(fields));
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      subject: "",
      from: "",
      email: "",
      message: "",
    },
  });

  const [extractedData, setExtractedData] = useState({});

  const [label, setLabel] = useState({});

  useEffect(() => {
    const extractData = () => {
      const extracted = {};

      for (const key in fields) {
        const id = key;
        // const element = fields?.find((el) => el.id);
        // if (element) {
        const labelCol = fields[key]?.label;
        extracted[id] = { id, label_col: labelCol };

        // }
      }

      return extracted;
    };

    const result = extractData();
    setExtractedData(result);
    const labels = Object.keys(result).map((key) => {
      return result[key].label_col;
    });

    setLabel(labels);
  }, []);

  const handleColDelete = (getValue: any) => {
    setSelectedObject(getValue);
    setIsOpen(true);
  };

  const headers: any[] = fields?.map((item: any, index: number) => ({
    header: item.label ?? "N/A",
    accessorKey: item?.id ?? "N/A",
    cell: ResolveData,
  }));
  headers?.unshift({
    header: "Date",
    accessorKey: "created",
    cell: ({ cell: { getValue } }) => {
      const value = getValue();
      if (!value) return <p>N/A</p>;

      const date = moment(value).format("YY-MM-DD");
      const time = moment(value).format("HH:mm:ss");

      return (
        <div className={tw`flex flex-col`}>
          <span className={tw`whitespace-nowrap`}>{date}</span>
          <span>{time}</span>
        </div>
      );
    },
  });
  isReply &&
    headers?.push({
      header: "Replied",
      accessorKey: "is_replied",
      cell: ({ getValue, row }: any) => {
        const rowId = row.original.id;
        return (
          <>
            <div
              className="cursor-pointer"
              onClick={() => {
                setIsReplyOpen(true);
                setSelectedObject(rowId);
              }}
            >
              {getValue() ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18457 2.99721 7.13633 4.39828 5.49707C5.79935 3.85782 7.69279 2.71538 9.79619 2.24015C11.8996 1.76491 14.1003 1.98234 16.07 2.86M22 4L12 14.01L9.00001 11.01"
                    stroke="#26C943"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 9L9 15M9 9L15 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                    stroke="red"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              )}
            </div>
          </>
        );
      },
    });

  headers?.push({
    header: "Action",
    accessorKey: "id",
    cell: ({ row, getValue }) => (
      <>
        <div className="flex flex-row gap-2 justify-start">
          <button onClick={() => handleColDelete(getValue)}>
            <DeleteIcon color={"var(--primary)"} />
          </button>
        </div>
      </>
    ),
  });
  const { mutateAsync: postReply, isPostLoading } = usePostHook({
    queryKey: ["form_data"],
    navigateURL: "",
  });
  console.log(selectedObject);
  const onSubmit = async (formValues: any) => {
    if (!selectedObject) return;

    const url = `${APIS.FORM_DATA}${selectedObject}/contact-reply/`;

    try {
      await postReply({ url, formData: formValues });
      reset();
      setIsReplyOpen(false);
    } catch (err) {
      console.error("Reply failed:", err);
    }
  };

  return (
    <>
      <DataTable
        columns={headers ?? []}
        url={`${APIS.FORM_DATA}`}
        params={{ form: formId }}
        queryKey={`form_data`}
        tableName={"form-data-list"}
        addNewPagePath="create"
      />
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        children={
          <ConfirmDialog
            setIsOpen={setIsOpen}
            handleDelete={() => handleDelete(setIsOpen, selectedObject)}
          />
        }
        title="Delete"
      />

      <Modal
        isOpen={isReplyOpen}
        setIsOpen={setIsReplyOpen}
        title="Reply"
        children={
          <form
            onSubmit={handleSubmit(onSubmit)}
            className={tw("flex flex-col gap-4 mt-4 w-[500px]")}
          >
            <div className={tw("flex items-center gap-2")}>
              <label className={tw("w-14 text-sm font-medium")}>Subject:</label>
              <div className={tw("flex-1 flex flex-col")}>
                <input
                  {...register("subject", { required: "Subject is required" })}
                  placeholder="Enter subject"
                  className={tw(
                    "w-full p-2 rounded border focus:outline-none",
                    errors.subject ? "border-red-500" : "border-gray-300"
                  )}
                />
                {errors.subject && (
                  <p className={tw("text-red-500 text-xs mt-1")}>
                    {errors.subject.message}
                  </p>
                )}
              </div>
            </div>

            <div className={tw("flex items-center gap-2 ")}>
              <label className={tw("w-14 text-sm font-medium")}>To:</label>
              <div className={tw("flex-1 flex flex-col")}>
                <input
                  {...register("email", {
                    required: "To is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter a valid email address",
                    },
                  })}
                  placeholder="Receiver email"
                  className={tw(
                    "w-full p-2 rounded border focus:outline-none",
                    errors.email ? "border-red-500" : "border-gray-300"
                  )}
                />
                {errors.email && (
                  <p className={tw("text-red-500 text-xs mt-1")}>
                    {errors.email.message}
                  </p>
                )}
              </div>
            </div>

            <div className={tw("flex flex-col")}>
              <label className={tw("text-sm font-medium mb-1")}>Message:</label>
              <textarea
                {...register("message", { required: "Message is required" })}
                rows={5}
                placeholder="Write your message..."
                className={tw(
                  "w-full p-2 rounded border focus:outline-none",
                  errors.message ? "border-red-500" : "border-gray-300"
                )}
              />
              {errors.message && (
                <p className={tw("text-red-500 text-xs mt-1")}>
                  {errors.message.message}
                </p>
              )}
            </div>

            <div className={tw("flex justify-end gap-3 mt-2")}>
              <button
                type="button"
                onClick={() => {
                  reset();
                  setIsReplyOpen(false);
                }}
                className={tw(
                  "px-4 py-2 rounded border border-gray-300 hover:bg-gray-100"
                )}
              >
                Cancel
              </button>

              <button
                type="submit"
                className={tw(
                  "px-4 py-2 rounded bg-primary text-white hover:bg-primary-dark"
                )}
              >
                Reply
              </button>
            </div>
          </form>
        }
      />
    </>
  );
};

export default SubmittedFormData;
